import { Modal, ModalBody, ModalHeader } from "reactstrap"
import * as React from "react"
import { observer } from "mobx-react"
import CreateEventForm, { CreateEventFormProps } from "./CreateEventForm"

type CreateEventModalProps = {
  isOpen: boolean
  toggle: () => void
} & CreateEventFormProps

@observer
export class CreateEventModal extends React.Component<CreateEventModalProps> {
  static defaultProps = {
    showCancelButton: true,
    clearAfterSave: true,
  }

  render (): React.ReactNode {
    const { isOpen, toggle, ...rest } = this.props

    return <Modal isOpen={isOpen} onClosed={this.props.onCancel} size="lg">
      <ModalHeader toggle={toggle}>
        Create Event
      </ModalHeader>
      <ModalBody>
        <CreateEventForm
          {...rest}
        />
      </ModalBody>
    </Modal>
  }
}